// Generated by ts-to-zod
import { z } from 'zod';
import { paginationQuerySchema } from '../../utils/listQuery.schema';
import { runStatusSchema, statusCodeSchema } from '../models/run.schema';
import { logLevelSchema } from '../models/runLog.schema';

export const runsQuerySchema = paginationQuerySchema.and(
  z
    .object({
      timestampAfter: z.string(),
      timestampBefore: z.string(),
      startAfter: z.string(),
      startBefore: z.string(),
      endAfter: z.string(),
      endBefore: z.string(),
      search: z.string(),
      hook: z.array(z.number()),
      uuid: z.array(z.string()),
      requestId: z.string(),
      logLevel: logLevelSchema,
      statusCode: z.array(statusCodeSchema),
      queue: z.array(z.string()),
      annotation: z.array(z.number()),
      email: z.array(z.string()),
      status: z.array(runStatusSchema),
    })
    .partial()
);
